export default __webpack_public_path__ + "static/media/illustration-elements_icon-linkedn.feb4f5ae.svg";